import TiptapEditor from "components/tiptap-editor";
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "ui/components/card";

export default function TicketDescription({ description }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Description</CardTitle>
      </CardHeader>
      <CardContent>
        {description ? (
          <TiptapEditor value={description} readOnly={true} />
        ) : (
          <p className="text-sm text-zinc-500">No description provided</p>
        )}
      </CardContent>
    </Card>
  );
}
